export default "__VITE_ASSET__DKq9JWWM__"